import { InjectionToken } from '@angular/core';
import { Environment } from '../../environments/enviroment.model';
export const StorageProvider = new InjectionToken<Storage>('storage');
export const HistoryProvider = new InjectionToken<History>('history');
export const LocationProvider = new InjectionToken<Location>('location');
export const EnvironmentProvider = new InjectionToken<Environment>('environment');



// WEBPACK FOOTER //
// ./src/app/core/browser-providers.ts